import { lazy } from "react";
import Loadable from "components/Loadable";
import { routeConstants, FormatConstants } from "services/keyConstants";
import { getStatusTypes } from "./service";
import {
  customerPropertyDownload,
  customerPropertyList,
} from "api/module/customerProperty";

// Lazy-loaded components
const Create = Loadable(lazy(() => import("../molecules/Create")));
const Report = Loadable(lazy(() => import("../Report")));
const ViewById = Loadable(lazy(() => import("../ViewById")));
const CommonDetail = Loadable(
  lazy(() => import("components/CommonDetail/CommonDetail")),
);

const CPRoutes = [
  {
    path: routeConstants.CUSTOMER_PROPERTY,
    children: [
      {
        path: "detail/:id",
        element: (
          <CommonDetail
            navigateRoute={{
              isCondition: false,
              url: (item) =>
                `/${routeConstants.CUSTOMER_PROPERTY}/view/${item?._id}`,
            }}
            url={{
              GET: customerPropertyList,
              DOWNLOAD: customerPropertyDownload,
            }}
            getStatusTypes={getStatusTypes}
            filterOptions={{
              [FormatConstants.CUSTOMER_PROPERTY.LIST_OF_CUSTOMER_PROPERTY]: [
                {
                  name: "Status",
                  optionsKey: "statusOptions",
                },
              ],
              [FormatConstants.CUSTOMER_PROPERTY
                .CUSTOMER_PROPERTY_REPORTING_FORM]: [
                {
                  name: "Status",
                  optionsKey: "statusOptions",
                },
              ],
            }}
            buttonsData={(masterDocData) => {
              return masterDocData?.defaultName ===
                FormatConstants.CUSTOMER_PROPERTY.LIST_OF_CUSTOMER_PROPERTY
                ? [
                    {
                      name: "Create",
                      route: `/customer-property/create`,
                    },
                  ]
                : masterDocData?.defaultName ===
                  FormatConstants.CUSTOMER_PROPERTY
                    .CUSTOMER_PROPERTY_REPORTING_FORM
                ? [
                    {
                      name: "Create",
                      route: `/customer-property/report`,
                    },
                  ]
                : null;
            }}
            tableConfig={{
              chip: {
                status: (data) => {
                  const status = data?.row?.status;
                  const color =
                    status === "Not Accepted"
                      ? "error"
                      : status === "Initiated"
                      ? "primary"
                      : "success";
                  return {
                    label: status,
                    color,
                  };
                },
              },
            }}
          />
        ),
      },
      {
        path: "create",
        element: <Create />,
      },
      {
        path: "view/:id",
        element: <ViewById />,
      },
      {
        path: "report/:id?",
        element: <Report />,
      },
    ],
  },
];

export default CPRoutes;
